import { render, staticRenderFns } from "./SedativeInput.vue?vue&type=template&id=5e652e0e"
import script from "./SedativeInput.vue?vue&type=script&lang=js"
export * from "./SedativeInput.vue?vue&type=script&lang=js"
import style0 from "./SedativeInput.vue?vue&type=style&index=0&id=5e652e0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports